// extracted by mini-css-extract-plugin
export default {"file":"styles_file__HSIju","holder":"styles_holder__oGp+r","inner":"styles_inner__by7yC","icon":"styles_icon__Ta3Ml"};